import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorColumnChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5ZM3.75 19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14Z"
    />
    <path
      fill="#F7A600"
      d="M12.95 9a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0V9ZM16.5 9.964a.75.75 0 0 1 .75.75V15a.75.75 0 1 1-1.5 0v-4.286a.75.75 0 0 1 .75-.75ZM8 10.564a.75.75 0 0 1 .75.75v3.6a.75.75 0 0 1-1.5 0v-3.6a.75.75 0 0 1 .75-.75Z"
    />
  </svg>
);
export default SvgTwoColorColumnChart;
